export default "__VITE_ASSET__992WGEAk__"